import React from 'react';
import { useSelector } from 'react-redux';

import { Meta, SystemIssues } from '@portals/framework';
import { getAuth } from '@portals/redux';
import { TenantType } from '@portals/types';

export const PartnersMeta = () => {
  const loggedIn = useSelector(getAuth);

  return (
    <>
      <Meta
        title="Xyte - HWaaS Platform"
        gtmId={process.env.NX_PARTNERS_GTM_ID}
      />

      {loggedIn && <SystemIssues tenantType={TenantType.Partner} />}
    </>
  );
};

export default PartnersMeta;
